import { SYSTEM_ANNOUNCEMENT_LOAD } from './systemAnnouncement.actionType';

const initialState = {
    systemName: '',
    startDateTime: '',
    endDateTime: '',
    information: '',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SYSTEM_ANNOUNCEMENT_LOAD:
            return {
                ...initialState,
                ...action.payload,
            };
        default:
            return state;
    }
};
